var _rect, _rect2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPortfolioStocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    fill: "var(--icon-asset-bg-primary)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 55,
    height: 55,
    rx: 27.5,
    stroke: "var(--icon-asset-bg-secondary)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8226 39.6123V36.0746C17.8226 35.5448 18.252 35.1154 18.7817 35.1154C19.3114 35.1154 19.7409 35.5448 19.7409 36.0746V39.6123C19.7408 40.142 19.3114 40.5715 18.7817 40.5715C18.2521 40.5715 17.8227 40.142 17.8226 39.6123Z",
    fill: "var(--secondary-color)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2857 39.4587L14.2857 21.7707C14.2857 21.241 14.7151 20.8116 15.2448 20.8116C15.7746 20.8116 16.204 21.241 16.204 21.7707L16.204 39.4587C16.204 39.9884 15.7746 40.4178 15.2448 40.4178C14.7151 40.4178 14.2857 39.9884 14.2857 39.4587Z",
    fill: "var(--primary-color)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1282 39.6123V31.9223C24.1282 31.3926 24.5576 30.9632 25.0873 30.9632C25.617 30.9632 26.0465 31.3926 26.0465 31.9223V39.6123C26.0465 40.1421 25.617 40.5715 25.0873 40.5715C24.5576 40.5715 24.1282 40.1421 24.1282 39.6123Z",
    fill: "var(--secondary-color)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5125 39.6123V33.7676C30.5125 33.2378 30.9419 32.8084 31.4716 32.8084C32.0013 32.8084 32.4307 33.2378 32.4307 33.7676V39.6123C32.4307 40.142 32.0013 40.5715 31.4716 40.5715C30.9419 40.5715 30.5125 40.142 30.5125 39.6123Z",
    fill: "var(--secondary-color)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8181 39.6123V28.5381C36.8181 28.0084 37.2475 27.579 37.7772 27.579C38.3069 27.579 38.7363 28.0084 38.7363 28.5381V39.6123C38.7363 40.142 38.3069 40.5714 37.7772 40.5714C37.2475 40.5714 36.8181 40.142 36.8181 39.6123Z",
    fill: "var(--secondary-color)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7033 22.9553C38.1101 22.6163 38.7148 22.6714 39.054 23.078C39.3931 23.4849 39.3382 24.0905 38.9313 24.4296L32.0103 30.1975C31.7239 30.4361 31.3247 30.4865 30.9874 30.3277L25.0396 27.529L19.3625 32.852C18.9761 33.214 18.3693 33.1943 18.0071 32.808C17.6448 32.4216 17.6647 31.814 18.0512 31.4517L24.2032 25.6847L24.3165 25.5929C24.5942 25.4023 24.956 25.3698 25.2672 25.5161L31.2516 28.3317L37.7033 22.9553Z",
    fill: "var(--secondary-color)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6746 21.9538C39.9353 21.9796 40.1762 22.1113 40.3385 22.321C40.5239 22.5605 40.5851 22.8736 40.5039 23.1653L39.6985 26.0586C39.5564 26.5689 39.0273 26.8668 38.517 26.7247C38.0068 26.5826 37.7083 26.0543 37.8504 25.544L38.3106 23.8895L36.6697 23.9204C36.1401 23.9301 35.7031 23.509 35.6932 22.9795C35.6835 22.45 36.1046 22.0129 36.6341 22.003L39.5625 21.9496L39.6746 21.9538Z",
    fill: "var(--secondary-color)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9084 15.4286L25.0096 15.4342C25.2444 15.4592 25.4629 15.5703 25.6221 15.748L29.0325 19.5546C29.3836 19.9465 29.3536 20.5476 28.9651 20.9025L25.5547 24.0178C25.3781 24.179 25.1475 24.2678 24.9084 24.2679H15.2448C14.7151 24.2679 14.2857 23.8385 14.2857 23.3087V16.3877C14.2857 15.858 14.7151 15.4286 15.2448 15.4286H24.9084ZM16.204 22.3496H24.5356L26.97 20.126L24.4804 17.3469H16.204V22.3496Z",
    fill: "var(--primary-color)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolioStocks);
export default __webpack_public_path__ + "static/media/portfolio-stocks.a42244aea4fff778be37a9c9be439a93.svg";
export { ForwardRef as ReactComponent };